import { useQuery } from '@tanstack/react-query';
import { folderService } from '../services/folderService';

export function useFolder(id: string | undefined) {
  return useQuery({
    queryKey: ['folder', id],
    queryFn: () => folderService.getFolder(id!),
    enabled: !!id,
  });
}
